import React from "react";
import Social from "../Social";

const heroContent = {
  shapeImage: "hero-shape",
  heroImage: "Bacim_Boulehmi",
  name: "Bacim Boulehmi",
  title: "React Developer & Product Builder",
  description:
    "I build scalable web applications, internal tools and digital products that solve real business problems.\nI combine clean frontend development, product thinking and AI\u2011assisted workflows.",
};

const Hero = () => {
  return (
    //    HERO
    <div className="edina_tm_hero" id="home">
      <div className="content">
        <div className="img-shape" data-aos="fade-up" data-aos-duration="1200">
          <img
            src={`img/hero/${heroContent.shapeImage}.jpg`}
            srcSet={`img/hero/${heroContent.heroImage}.png`}
            alt="Bacim"
          />
        </div>
        <div className="extra">
          <h1
            className="name"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="100"
          >
            {heroContent.name}
          </h1>
          <h2
            className="designation"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="150"
          >
            {heroContent.title}
          </h2>
          <p
            className="text hero-description"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="200"
          >
            {heroContent.description}
          </p>

          <div
            className="social"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="300"
          >
            <Social />
          </div>
          <div
            className="edina_tm_button"
            data-aos="fade-up"
            data-aos-duration="1200"
            data-aos-delay="400"
          >
            <a href="Bacim.pdf" download className="color">
              Download CV
            </a>
          </div>
        </div>
      </div>
    </div>
    // /HERO
  );
};

export default Hero;
